import React, { Component,  } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import classes from '*.module.css';
import { createStyles, withStyles, WithStyles } from '@material-ui/core';
const styles = () =>
  createStyles({
    progressBar: {
      borderRadius: 5
    },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: '4px 8px',
      backgroundColor: '#E8E8E8',
      width: '28%',
      minWidth: 85,
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    progressPercent:{
      fontSize: 14,
      color: '#333',
      fontWeight: 600,
    },
    colorSecondary: {
      backgroundColor: '#EB4F4F',
      color: '5.5px 5px 5px 5.5px'
    },
    colorprimary: {
      backgroundColor: '#1d7dea',
      color: '5.5px 5px 5px 5.5px'
    },
    colorSuccess: {
        backgroundColor: '#67BF02',
        color: '5.5px 5px 5px 5.5px'
      },
    progressLabel:{
      fontSize: 14,
      color: '#999',
    },
    progressCount:{
        fontSize: 14,
        color: '#333',
        fontWeight: 600,
    },
    progressParent:{
      display: 'flex',
      alignItems: 'center',
      lineHeight: '1.75rem'
    }
  });
  interface Props extends WithStyles<typeof styles> {
    
  }
  class ProgressBar extends Component<any>{

    render() {
        // const {classes} = this.props;
        const { percentage, marginLeft, totalCount, count, width, classes } = this.props;
        return (
            <div className={classes.progressParent}>
              <span className={classes.progressLabel}>Progress:</span>&nbsp;<span className={classes.progressCount}>{count?count:'0'}/{totalCount?totalCount:'0'}</span>
                <LinearProgress variant="determinate" value={percentage}
                  classes={{
                  colorSecondary: classes.colorprimary,
                  barColorPrimary: classes.colorprimary,
                  bar: classes.progressBar, root: classes.linearProgressBar
              }}
               />
              <span className={classes.progressCount}>{percentage?Math.round(percentage * 100) / 100:'0'}%</span>
            </div>
        )
    }
}

export default withStyles(styles)(ProgressBar);

